export default __webpack_public_path__ + "static/media/belfor-logo-small-black.d1104e9b.png";